import styled from 'styled-components';
import ControllRightBar from './ControllRightBar';
import ControllCenterBar from './ControllCenterBar';
import ControllLeftBar from './ControllLeftBar';
import { Dispatch, SetStateAction } from 'react';
import { WebSDKcctv } from '../../../../utils/webSDKcctvClass';

const Root = styled.div`
  height: 3rem;
  width: 100%;
  background-color: var(--black);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
`;

interface Props {
  visiblePanel: boolean;
  setVisiblePanel: Dispatch<SetStateAction<boolean>>;
  cctvOBJ: WebSDKcctv | undefined; // cctv 객체
  cctvDivisions: number; // cctv 분할
  onClickDivision: (number: 1 | 2 | 3 | 4) => void;
  selectedCameraInfo: SelectedCctvCameraInfo;
  setSelectedCameraInfo: Dispatch<SetStateAction<SelectedCctvCameraInfo>>;
  nvrList: IMainMenu[];
  setNvrList: Dispatch<SetStateAction<IMainMenu[]>>;
  currentDate?: string;
  videoWindow: VideoWindow;
  onClickPlay: (param: { reverse?: boolean; currentTime?: number }) => void;
  onClickPause: () => void;
  cctvSettings: CctvSettings;
  onClickSpeed: (speed: 'fast' | 'slow') => void;
  windows: {
    windowIndex: number;
    clock: {
      currentTime: number; //
      setCurrentTime: Dispatch<SetStateAction<number>>;
      setIsPlaying: Dispatch<SetStateAction<boolean>>;
      setSpeed: Dispatch<SetStateAction<1 | 2 | 4>>;
      speed: 1 | 2 | 4;
      currentDate: string;
      setCurrentDate: Dispatch<SetStateAction<string>>;
      isReversed: boolean;
      setIsReversed: Dispatch<SetStateAction<boolean>>;
    };
  }[];
}

const ControllBar = ({
  visiblePanel,
  setVisiblePanel,
  cctvOBJ,
  cctvDivisions,
  onClickDivision,
  selectedCameraInfo,
  setSelectedCameraInfo,
  nvrList,
  setNvrList,
  currentDate,
  videoWindow,
  onClickPlay,
  onClickPause,
  cctvSettings,
  onClickSpeed,
  windows,
}: Props) => {
  return (
    <Root className='controllBar'>
      <ControllLeftBar //
        cctvOBJ={cctvOBJ}
        visiblePanel={visiblePanel}
        setVisiblePanel={setVisiblePanel}
        cctvDivisions={cctvDivisions}
        onClickDivision={onClickDivision}
        selectedCameraInfo={selectedCameraInfo}
        onClickSpeed={onClickSpeed}
        videoWindow={videoWindow}
      />
      <ControllCenterBar //
        cctvOBJ={cctvOBJ}
        selectedCameraInfo={selectedCameraInfo}
        setSelectedCameraInfo={setSelectedCameraInfo}
        nvrList={nvrList}
        setNvrList={setNvrList}
        onClickPlay={onClickPlay}
        onClickPause={onClickPause}
        videoWindow={videoWindow}
      />
      <ControllRightBar
        cctvOBJ={cctvOBJ}
        selectedCameraInfo={selectedCameraInfo}
        setSelectedCameraInfo={setSelectedCameraInfo}
        nvrList={nvrList}
        setNvrList={setNvrList}
        cctvSettings={cctvSettings}
        windows={windows}
      />
    </Root>
  );
};

export default ControllBar;
